<template>
  <section class="question-stem-preview">
    <v-btn
      v-if="adminEditMode"
      type="button"
      class="question-stem-preview__edit mb-3"
      color="primary"
      density="comfortable"
      prepend-icon="mdi-pencil"
      size="small"
      variant="tonal"
      @click="emit('edit-section', 'basic')"
    >
      Edit stem
    </v-btn>

    <div v-if="questionImages.length > 0" class="mb-6">
      <v-row wrap>
        <v-col
          v-for="imageId in questionImages"
          :key="imageId"
          :cols="questionImageColsValue"
        >
          <ImgExpander height="200" :src="allImgPaths[imageId]" />
        </v-col>
      </v-row>
    </div>

    <div class="v-html-content" v-html="questionText"></div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import ImgExpander from "@/components/ImgExpander.vue";

const props = defineProps({
  questionText: {
    type: String,
    default: "",
  },
  questionImages: {
    type: Array,
    default: () => [],
  },
  questionImageCols: {
    type: Number,
    default: 1,
  },
  allImgPaths: {
    type: Object,
    required: true,
  },
  adminEditMode: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["edit-section"]);

const questionImageColsValue = computed(() => {
  if (props.questionImageCols === 2) return 6;
  if (props.questionImageCols === 3) return 4;
  return 12;
});
</script>
